import { RenderComponent } from '@bcp-channels-sharedcomponents-reactjs/core';

import { UserIsClientAbModal } from './userIsClient.ab';
import { UserIsClientBcpModal } from './userIsClient.bcp';

export const UserIsClientModal = () => {
	return (
		<RenderComponent
			components={{
				ab: {
					desktop: <UserIsClientAbModal />,
					mobile: <UserIsClientAbModal />,
					intranet: null,
				},
				bcp: {
					desktop: <UserIsClientBcpModal />,
					mobile: <UserIsClientBcpModal />,
					intranet: null,
				},
			}}
		/>
	);
};
